export default "__VITE_ASSET__BxdjGC8q__"